import { colors } from "@mui/material";
import { GridRowClassNameParams } from "@mui/x-data-grid-pro";

const tableStyles = {
  root: {
    ".MuiDataGrid-colCell": {
      width: "100% !important",
    },
    ".MuiDataGrid-row": {
      width: "100%",
    },
    "& .assignees-column:focus-within": {
      outline: "none !important",
    },
    "& .evenRow": {
      backgroundColor: "#ffffff",
    },
    "& .MuiDataGrid-cell": {
      alignItems: "center",
      display: "flex",
    },
    "& .MuiDataGrid-cell > *:not(.MuiChip-root)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "rgb(255, 255, 255)",
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiDataGrid-overlayWrapper, & .MuiDataGrid-overlayWrapperInner, & .MuiDataGrid-overlay": {
      left: 0,
      minHeight: "100%",
      minWidth: "100%",
      position: "absolute",
      top: 0,
    },
    "& .MuiDataGrid-virtualScroller": {
      height: "calc(100vh - 305px)",
    },
    "& .MuiTablePagination-spacer": {
      order: 2,
    },
    "& .oddRow": {
      backgroundColor: colors.grey[50],
    },
    "&.sources-height .MuiDataGrid-virtualScroller": {
      height: "calc(100vh - 378px)",
    },
    "&.tab-height .MuiDataGrid-virtualScroller": {
      height: "calc(100vh - 362px)",
    },
    backgroundColor: "white",
    borderRadius: 0,
    flexGrow: 1,
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  stretchColumns: {
    ".MuiDataGrid-cell": {
      alignItems: "center",
      display: "flex",
      justifyContent: "stretch",
    },
  },
};

const getRowClassName = (parameters: GridRowClassNameParams) =>
  parameters.indexRelativeToCurrentPage % 2 === 0 ? "evenRow" : "oddRow";

export { getRowClassName, tableStyles };
